import axiosInstance from "../utils/axios";
import { ActivityCalculatorSettingsFull } from "../@types/activityCalculatorSettings";

const BASE_URL = "/cms/v1/component-settings/activity-calculator";
async function getActivityCalculatorSettingsByMerchantCodeApi(merchantCode: string) {
  return axiosInstance.get(`${BASE_URL}`, { params: { merchantCode } });
}

async function saveActivityCalculatorSettingsApi(merchantCode: string, data: ActivityCalculatorSettingsFull) {
  const savedSettings = await axiosInstance.post(`${BASE_URL}`, JSON.stringify(data));
  const activityCalculatorId = savedSettings.data.id;
  await connectMerchantToActivityCalculatorApi(merchantCode, activityCalculatorId);
  return savedSettings;
}

async function connectMerchantToActivityCalculatorApi(merchantCode: string, activityCalculatorId: string) {
  return axiosInstance.post(`${BASE_URL}/${activityCalculatorId}/merchant/${merchantCode}`)
}

async function updateActivityCalculatorSettingsApi(id: string, data: ActivityCalculatorSettingsFull) {
  return axiosInstance.put(`${BASE_URL}/${id}`, data);
}

async function getActivityCalculatorSettingsByIdApi(id: string) {
  return axiosInstance.get(`${BASE_URL}/${id}`);
}

export {
  getActivityCalculatorSettingsByMerchantCodeApi,
  saveActivityCalculatorSettingsApi,
  updateActivityCalculatorSettingsApi,
  getActivityCalculatorSettingsByIdApi
};